export default {
	state: {	
		isCollapse: false,//左侧菜单展开收起属性
		//面包屑导航数据
		navbar: [{
				path: '/',
				name: 'home',
				lable: '首页',
				icon: 'home'
			}
		],
		currentNav: null
	},
	mutations: {
		//左侧菜单开关
		collapseMenu(state) {
			//console.log(state);
			state.isCollapse = !state.isCollapse;
		},
		//更新面包屑数据
		setNavMenu(state,val){
			console.log(state,val);
			if(val.name!=='home'){
				state.currentNav=val;
				const res=state.navbar.findIndex(item=>item.name===val.name);
				if(res === -1){
					state.navbar.push(val)
				}
			}else{
				state.navbar.currentNav=null;
			}
		}
	}
}
